import { Directive, ViewChild } from '@angular/core';
import { HasSubscriptionsToClose } from '@agingplan';
import { ModalComponent } from './modal.component';

@Directive({
  selector: 'opens-modals',
})
export class OpensModals extends HasSubscriptionsToClose() {
  /**
   * The reference to the modal within the template of the inheriting component
   */
  @ViewChild('modal') modal?: ModalComponent;

  /**
   * Is the modal visible?
   */
  public get visible(): boolean {
    return this.modal?.visible || false;
  }

  /**
   * The name of the component extending the OpensModals directive
   */
  private _name = '';
  public get name(): string {
    return this._name ?? this.constructor.name;
  }
  public set name(name: string) {
    this._name = name;
  }

  /**
   * Open the modal
   */
  public async open() {
    if (this.modal) {
      // Return the result of the modal when it is closed and dismissed
      return await this.modal.open();
    }

    // Throw an error if the template is not found
    throw new Error('OpensModals: Template not found!');
  }
}
